import Measure from "./measure";
import Measure3DHelper from "./measure3DHelper";
import uuid from "../../utils/uuid";
class PolygonVolume3D extends Measure {
  static Type = "volume";
  constructor(lineCoordinates, name, viewer) {
    super(name, PolygonVolume3D.Type);
    this.potreeMeasure = new window.Potree.ExtendedMeasure(viewer); // todo: use import
    this.potreeMeasure.showDistances = false;
    this.potreeMeasure.showTotalLength = false;
    this.potreeMeasure.showArea = false;
    this.potreeMeasure.showPolygonVolume = true;
    this.potreeMeasure.closed = true;
    this.potreeMeasure.name = name;
    this.id = this.potreeMeasure.dbId || uuid();
    this.potreeMeasure.measureType = "volume";
    Measure3DHelper.initMarkers(this.potreeMeasure, lineCoordinates);
  }

  getLength() {
    return this.potreeMeasure.getLength();
  }

  getResult() {
    return this.getLength();
  }

  serialize() {
    return {
      ...super.serialize(),
      ...Measure3DHelper.serialize(this.potreeMeasure),
    };
  }

  static fromPotreeMeasure(potreeMeasure) {
    let measure = new PolygonVolume3D([], potreeMeasure.name);
    measure.potreeMeasure = potreeMeasure;
    measure.id = potreeMeasure.dbId;
    measure.toBeStored = potreeMeasure.toBeStored;
    measure.dbId = potreeMeasure.dbId;
    return measure;
  }

  static fromSerialized(serialized) {
    let measure = new PolygonVolume3D(serialized.points, serialized.name);
    measure.id = serialized.id;
    measure.toBeStored = serialized.toBeStored;
    measure.potreeMeasure.toBeStored = serialized.toBeStored;
    measure.potreeMeasure.dbId = serialized.dbId;
    measure.dbId = serialized.dbId;
    return measure;
  }
}

export default PolygonVolume3D;
